// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__6ZXtv","legacyBtn":"MutateMid_legacyBtn__3ajhd"};